import React from "react";
import TradieDashboard from "./TradieDashboard";

// TradieApp is the tradie-side container. It will gain its own internal
// navigation (calendar, invoices, accounting) as those features are built.
export default function TradieApp({
  profile,
  requests,
  leadsLoading,
  updateRequestStatus,
  createOnsiteQuoteLead,
  saveQuote,
  unlockLead,
  unlockedLeadIds,
  creditBalance,
  getCustomerQuoteLink,
  getCustomerInvoiceLink,
  loadLeadDetails,
  businessId,
  bookJob,
  dismissLead,
  undismissLead,
  dismissedLeadIds,
  updateLeadStage,
  archiveLead,
  unarchiveLead,
  updateLeadContactDetails,
  subscription,
  showPricing,
  setShowPricing,
  onGoToSettings,
}) {
  return (
    <TradieDashboard
      profile={profile}
      requests={requests}
      leadsLoading={leadsLoading}
      updateRequestStatus={updateRequestStatus}
      createOnsiteQuoteLead={createOnsiteQuoteLead}
      saveQuote={saveQuote}
      unlockLead={unlockLead}
      unlockedLeadIds={unlockedLeadIds}
      creditBalance={creditBalance}
      getCustomerQuoteLink={getCustomerQuoteLink}
      getCustomerInvoiceLink={getCustomerInvoiceLink}
      loadLeadDetails={loadLeadDetails}
      businessId={businessId}
      bookJob={bookJob}
      dismissLead={dismissLead}
      undismissLead={undismissLead}
      dismissedLeadIds={dismissedLeadIds}
      updateLeadStage={updateLeadStage}
      archiveLead={archiveLead}
      unarchiveLead={unarchiveLead}
      updateLeadContactDetails={updateLeadContactDetails}
      subscription={subscription}
      showPricing={showPricing}
      setShowPricing={setShowPricing}
      onGoToSettings={onGoToSettings}
    />
  );
}
